// Disponibili.tsx — v033: /disponibili, «Sfida uno sconosciuto». L'elenco di chi è online adesso e accetta sfide da
// chiunque: si sceglie chi sfidare (scelta del proprietario: niente abbinamento casuale, che Apple non accetta — regola
// 1.2, «random or anonymous chat»). Solo con l'account e da maggiorenni. Sopra, l'invito a farsi trovare anche noi.
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Palco } from "../componenti/Palco.tsx";
import { Indietro } from "../componenti/Indietro.tsx";
import { aggiornaIo, useAccount } from "../servizi/account.ts";
import { leggiDisponibili, type Persona } from "../servizi/amici.ts";
import { sfidaProfilo } from "../servizi/social.ts";
import { vai } from "../servizi/percorso.ts";
import { PERCORSO_ACCESSO, PERCORSO_AMICI } from "../costanti.ts";
import { ErroreSfida, IconaSfida, RigaPersona, usaSfidaPersona } from "./Persone.tsx";
import { ScegliChiSfida } from "./ChiPuoSfidare.tsx";

const AGGIORNA_MS = 15_000;

export function Disponibili({ onIndietro }: { onIndietro: () => void }) {
  const { t } = useTranslation();
  const account = useAccount();
  const io = account.tipo === "registrato" ? account.io : null;
  const [persone, setPersone] = useState<Persona[] | null>(null);
  const [puoi, setPuoi] = useState(true);
  const [errore, setErrore] = useState(false);
  const { sfida, invio, errore: erroreSfida } = usaSfidaPersona();

  const carica = useCallback(async () => {
    try {
      const r = await leggiDisponibili();
      setPersone(r.persone);
      setPuoi(r.puoi);
      setErrore(false);
    } catch {
      setErrore(true);
    }
  }, []);
  useEffect(() => {
    if (!io) return;
    void carica();
    const id = setInterval(() => document.visibilityState === "visible" && void carica(), AGGIORNA_MS);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [io?.id, carica]);

  return (
    <div className="pagina pagina-account ld-pagina">
      <header className="ld-barra">
        <Indietro onClick={onIndietro} />
        <span />
      </header>
      <main className="account-centro ld-disponibili">
        <Palco mascotte="caso" colore="lilla" titolo={t("disponibili.titolo")} sottotitolo={t("disponibili.sotto")} />
        {!io ? (
          <section className="scheda-account">
            <p>{t("disponibili.serve_account")}</p>
            <button type="button" className="pulsante pulsante-primario" onClick={() => vai(PERCORSO_ACCESSO)}>
              {t("account.accedi")}
            </button>
          </section>
        ) : !puoi || !io.puoLink ? (
          <section className="scheda-account">
            <p>{t("disponibili.solo_maggiorenni")}</p>
            <button type="button" className="pulsante pulsante-secondario" onClick={() => vai(PERCORSO_AMICI)}>
              {t("amici.titolo")}
            </button>
          </section>
        ) : (
          <>
            {!io.apertoATutti && (
              <section className="scheda-account ld-fatti-trovare">
                <p className="ld-fatti-trovare-titolo">{t("disponibili.fatti_trovare")}</p>
                <p className="nota">{t("disponibili.fatti_trovare_testo")}</p>
                <ScegliChiSfida io={io} soloChiunque onCambiato={() => void aggiornaIo().catch(() => undefined)} />
              </section>
            )}
            <ErroreSfida codice={erroreSfida} />
            {errore && !persone && <p className="nota" role="alert">{t("account.errore_generico")}</p>}
            {!persone && !errore && <p className="nota" aria-busy="true">{t("generale.caricamento")}</p>}
            {persone && persone.length > 0 && (
              <section className="scheda-account" aria-labelledby="disponibili-elenco">
                <h2 className="scheda-titolo" id="disponibili-elenco">
                  <span className="ld-pallino ld-pallino-vivo" data-online="true" aria-hidden="true" /> {t("disponibili.ora", { n: persone.length })}
                </h2>
                <ul className="ld-persone">
                  {persone.map((p, i) => (
                    <RigaPersona key={p.nomeUtente ?? p.nome} nome={p.nome} nomeUtente={p.nomeUtente} avatar={p.avatar} online>
                      {p.nomeUtente && (
                        <button
                          type="button"
                          className="pulsante pulsante-primario pulsante-piccolo ld-sfida-persona"
                          style={{ animationDelay: `${i * 60}ms` }}
                          disabled={invio !== null}
                          onClick={() => void sfida(`d${p.nomeUtente}`, (n) => sfidaProfilo(p.nomeUtente!, n))}
                        >
                          {invio === `d${p.nomeUtente}` ? t("generale.caricamento") : t("amici.sfida")}
                          <IconaSfida />
                        </button>
                      )}
                    </RigaPersona>
                  ))}
                </ul>
              </section>
            )}
            {persone && persone.length === 0 && (
              <section className="scheda-account ld-disponibili-vuoto">
                <span className="ld-radar" aria-hidden="true">
                  <span />
                  <span />
                  <span />
                </span>
                <p className="ld-amici-vuoto-titolo">{t("disponibili.nessuno")}</p>
                <p className="nota">{t("disponibili.nessuno_testo")}</p>
                <button type="button" className="pulsante pulsante-primario" onClick={() => vai("/?nuova=1")}>
                  {t("home.sfida")}
                </button>
              </section>
            )}
            <p className="nota-centrata">{t("disponibili.regole")}</p>
          </>
        )}
      </main>
    </div>
  );
}
